<template>
  <div>
    <div class="safe-setting-wrapper">
      <div class="safe-setting-left">
        <p class="safe-setting-tip">登录双重验证</p>
        <div class="safe-setting-content">
          启用登录双重验证后，使用账号密码登录时，需通过短信验证码再次进行用户身份验证，进一步提高账号安全性。
        </div>
      </div>
      <div class="safe-setting-right">
        <a-switch
          v-model="switchOpen"
          @change="onChange"
        />
      </div>
    </div>
    <div class="safe-setting-wrapper">
      <div class="safe-setting-left">
        <p class="safe-setting-tip">项目选择页面设置</p>
        <div class="safe-setting-content">
          关闭该页面设置后,用户登录成功将跳过项目选择页面,自动选中上次退出系统时的项目进入系统。
        </div>
      </div>
      <div class="safe-setting-right">
        <a-switch
          :checked="openProjectSelection"
          @change="onProjectChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "personal-setting",
  data () {
    return {
      visible: true,
      switchOpen: false,
      switchProjectOpen: false
    }
  },
  props: {
    openSafeSetting: {
      type: Boolean,
      default: false
    },
    openProjectSelection: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    openSafeSetting (newV) {
      this.switchOpen = newV
    }
  },
  mounted () {
    this.switchOpen = this.openSafeSetting
  },
  methods: {
    onChange (v) {
      this.$emit('submitSafeSetting', this.switchOpen)
    },
    handleCancel () {
      this.$emit('hideSafeSetting', false)
    },
    onProjectChange (v) {
      this.$emit('submitProjectSetting', v)
    }
  }
}
</script>
<style lang="less" scoped>
.safe-setting-wrapper {
  display: flex;
  align-items: center;
  .safe-setting-left {
    flex: 1;
    .safe-setting-tip {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      margin-bottom: 8px;
    }
    .safe-setting-content {
      line-height: 20px;
      font-size: 14px;
      color: #8c8c8c;
    }
  }
  .safe-setting-right {
    flex-shrink: 0;
    margin-left: 24px;
  }
}
.safe-setting-wrapper:first-of-type {
  margin-bottom: 24px;
}
</style>